import { useEffect, useRef, useState } from "react";

import { tvErrorMessage } from "../Lib";

/**
 * Поиск с задержкой: запрос уходит, когда редактор перестал печатать.
 * [depsKey] — всё, от чего ещё зависит запрос (лига, тип тега): при смене поиск повторяется.
 */
export const useDebouncedSearch = <T>(
  load: (text: string) => Promise<T[]>,
  depsKey = "",
  delay = 350
) => {
  const [text, setText] = useState("");
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const loadRef = useRef(load);
  const seq = useRef(0);
  loadRef.current = load;

  useEffect(() => {
    const current = ++seq.current;
    setLoading(true);
    const timer = setTimeout(() => {
      loadRef
        .current(text)
        .then((result) => {
          if (current === seq.current) {
            setItems(result);
            setError(undefined);
          }
        })
        .catch((e) => current === seq.current && setError(tvErrorMessage(e)))
        .finally(() => current === seq.current && setLoading(false));
    }, delay);
    return () => clearTimeout(timer);
  }, [text, depsKey, delay]);

  return { items, loading, error, setText };
};
